<template>
  <b-container fluid class="dashboard">
    <b-row>
      <b-col>
        <div class="text-left text-uppercase title p-3">
          Dashboard
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="4" md="4" sm="12" xs="12" class="box mt-3">
        <div class="section p-3">
          Total Portfolios
          <div class="bigNumber">
            {{ totalPortfolios }}
          </div>
        </div>
      </b-col>
      <b-col lg="4" md="4" sm="12" xs="12" class="box mt-3">
        <div class="section contactUs p-3">
          Total Products
          <div class="bigNumber">
            {{ totalProducts }}
          </div>
        </div>
      </b-col>
      <b-col lg="4" md="4" sm="12" xs="12" class="box mt-3">
        <div class="section subscriber p-3">
          Total Clients
          <div class="bigNumber">
            {{ totalClients }}
          </div>
        </div>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'Dashboard',
  data () {
    return {
      totalPortfolios: 0,
      totalProducts: 0,
      totalClients: 0
    }
  },
  methods: {
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    },
    getAllInquiries (page) {
      this.isLoading = true
      this.$store.dispatch('getAllInquiries', {
        data: {
          page: page,
          size: 5
        },
        success: (res) => {
        },
        fail: () => {
          this.toast('Could not get inquiries. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findAllClients () {
      this.isLoading = true
      this.$store.dispatch('findAllClients', {
        success: (res) => {
          this.$data.totalClients = res.body.meta.pagination.total
          // this.$data.clientList = res.body.data
          // this.$data.totalPortfolios = res.body.data
        },
        fail: () => {
          this.toast('Could not get clients. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findAllProjects () {
      this.isLoading = true
      this.$store.dispatch('getProjectList', {
        success: (res) => {
          this.$data.totalPortfolios = res.body.meta.pagination.total
        },
        fail: () => {
          this.toast('Could not get projects. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findAllProducts () {
      this.isLoading = true
      this.$store.dispatch('getProductList', {
        success: (res) => {
          console.log('res is ', res)
          this.$data.totalProducts = res.body.meta.pagination.total
        },
        fail: () => {
          this.toast('Could not get products. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    }
    // findAllSubscribers (page) {
    //   this.$store.dispatch('findAllSubscribers', {
    //     data: {
    //       page: page,
    //       size: 3
    //     },
    //     success: (res) => {
    //       console.log('success')
    //     },
    //     fail: (res) => {
    //       this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
    //     }
    //   }).then(() => {
    //     this.isLoading = false
    //   }).catch(err => {
    //     console.error('error: ' + err)
    //   })
    // }
  },
  created () {
    // this.getAllInquiries(0)
    // this.findAllSubscribers(0)
    this.findAllClients()
    this.findAllProducts()
    this.findAllProjects()
  },
  computed: {
    ...mapGetters([
      'totalInquiries', 'inquiries', 'subscribers', 'totalSubscribers'
    ])
  }
}
</script>

<style scoped>
.dashboard {
  min-height: 100vh;
}
.title {
  border-bottom: 1px solid #ccc;
}
.box .section {
  border: 1px solid #000;
}
.bigNumber {
  color: #FF8F00;
  font-weight: bold;
  font-size: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue